module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_shangal_sm-c33acea70952f4da371b4b919aede1b6.png";